import React, { useState, useEffect } from 'react'
import { ChatAssistantIcon } from '../../Assets/Images/icons/chatAssistantIcon'
import ChatAssistantCloseIcon from '../../Assets/Images/icons/chatAssistantCloseIcon'
import ChatIconV2 from '../../Assets/Images/icons/chatIconV2'
import AssistantIcon from '../../Assets/Images/icons/assistantIcon'
import { makeStyles } from '@material-ui/styles'
import { styles } from './styles'
import SelfServeClientChat from '../SelfServeClientChat/container'

export const HelpAssistant = ({
  user,
  toggleAssistant,
  enableOnboardingAssistant,
}) => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)
  const [darkScreen, setDarkScreen] = useState(false)
  const [isChat, setIsChat] = useState(false)
  const isChatEnabled = user.client && user.client.countryId

  const handleDarkScreenClick = () => {
    setIsOpen(false)
    setDarkScreen(false)
  }

  // Spread events to open the chat in mobile view.
  useEffect(() => {
    document.addEventListener('campaign:chat_expert', event => {
      setIsChat(true)
    })

    document.addEventListener('campaign:create', event => {
      setIsChat(true)
    })

    return () => {
      document.removeEventListener('campaign:chat_expert', () => {})
      document.removeEventListener('campaign:create', () => {})
    }
  }, [])

  return (
    <div>
      {darkScreen && (
        <div className={classes.darkScreen} onClick={handleDarkScreenClick} />
      )}
      <div>
        {isChat ? (
          <SelfServeClientChat
            user={user}
            client={user.client}
            countryId={String(user.client.countryId)}
            openChat
            toggleAssistant={toggleAssistant}
          />
        ) : !isOpen ? (
          <div
            className={`${classes.root} ${classes.buttonShape}`}
            onClick={() => {
              setIsOpen(true)
              setDarkScreen(true)
            }}
          >
            <ChatAssistantIcon />
          </div>
        ) : (
          <div className={`${classes.root} ${classes.closeWrapper}`}>
            <div
              className={classes.buttonShape}
              onClick={() => {
                setIsOpen(false)
                setDarkScreen(false)
              }}
            >
              <ChatAssistantCloseIcon />
            </div>
            {enableOnboardingAssistant && (
              <div className={classes.textButtonContainer}>
                <p className={classes.helpAssistantText}>
                  Onboarding Assistant
                </p>
                <div
                  className={classes.chatAssistantShape}
                  onClick={() => {
                    toggleAssistant()
                    setDarkScreen(false)
                    setIsOpen(false)
                  }}
                >
                  <AssistantIcon />
                </div>
              </div>
            )}
            {isChatEnabled && (
              <div className={classes.textButtonContainer}>
                <p className={classes.helpAssistantText}>Chat</p>
                <div
                  className={classes.chatAssistantShape}
                  onClick={() => {
                    setIsChat(true)
                    setDarkScreen(false)
                  }}
                >
                  <ChatIconV2 />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default HelpAssistant
